const MOCK_DATA = {
  no: "2024/07/05 -2",
  tel: "07082325822",
  businessNum: "631-88-00743",
  name: "남궁창",
  companyName: "(주)제이브이코리아",
  address: "경기도 수원시 권선구 산업로 155번길 50(고색동)",
  orderData: [
    {
      date: "07/05",
      productName: "P14938",
      count: 600,
      unit: "EA",
      unitPrice: 200,
      supplyPrice: 120000,
      surtax: 12000
    },
    {
      date: "07/05",
      productName: "P20238",
      count: 300,
      unit: "AA",
      unitPrice: 100,
      supplyPrice: 30000,
      surtax: 3000
    },
    {
      date: "07/05",
      productName: "P10000",
      count: 900,
      unit: "E",
      unitPrice: 200,
      supplyPrice: 180000,
      surtax: 18000
    },
    {
      date: "07/05",
      productName: "P10101",
      count: 600,
      unit: "Ee",
      unitPrice: 400,
      supplyPrice: 240000,
      surtax: 24000
    }
  ]
}

export default MOCK_DATA;